import { Text, type TextProps, type TextStyle } from 'react-native';

import { useAppMetaStore } from '@/store/app-meta-store';
import { type } from '@/theme/tokens';

type Variant = keyof typeof type;

interface AppTextProps extends TextProps {
  variant?: Variant;
  color?: string;
}

/** Typography wrapper — always Quicksand, variants from DESIGN.md.
 *  Every size is multiplied by the user's global fontScale (Więcej → Rozmiar
 *  czcionki) so the whole UI shrinks/grows together (owner request). The scaled
 *  size sits before `style`, so an explicit inline fontSize (big hero amounts)
 *  still wins. */
export function AppText({ variant = 'bodyMd', color, style, ...rest }: AppTextProps) {
  const base = type[variant] as TextStyle;
  const scale = useAppMetaStore((s) => s.fontScale);
  const scaled =
    scale !== 1 && base.fontSize
      ? { fontSize: base.fontSize * scale, lineHeight: (base.lineHeight ?? base.fontSize * 1.3) * scale }
      : null;
  return <Text {...rest} style={[base, scaled, color ? { color } : null, style]} />;
}
